import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AppV2 } from './AppV2';
import { ScoreResultsPage } from './components/ScoreResultsPage';
import { AuditRequestPage } from './components/AuditRequestPage';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
const path = window.location.pathname.replace(/\/+$/, '');
function renderPage() {
  if (path === '/score') {
    return <ScoreResultsPage search={window.location.search} data-id="element-1100" data-mp="2f974y2porgv3" />;
  }
  if (path === '/audit') {
    return <AuditRequestPage data-id="element-1101" data-mp="2k05pjehpj145" />;
  }
  // Previous homepage retained for reference
  if (path === '/v1') {
    return <App data-id="element-1102" data-mp="2p01t5cmhsqj6" />;
  }
  // Approved homepage is the default at / (and /v2 for continuity)
  return <AppV2 data-id="element-1103" data-mp="2tzeo6knip3wu" />;
}
createRoot(rootElement).render(renderPage());